import React from "react";
import { Doughnut } from "react-chartjs-2";
import { AnalyticsApi } from "../../api/user";
import { Goals } from "../../models/Goals";
import { Macronutrient } from "../../models/MacroNutrient";
import { Util } from "../../models/Util";
import "./MacroNutrients.scss";

export enum GraphMode {
	standard = 1,
	option = 2,
	customize = 3,
}



interface MacroNutrientProp {
	goal: Goals;
	valueSelected(response?: any): void;
}

const MacroNutrient: React.FC<MacroNutrientProp> = ({ goal, valueSelected }): JSX.Element => {
	const [mode, setMode] = React.useState(GraphMode.standard);
	const [graphData, setGraphData] = React.useState(Util.graphState);
	const [macroRatio, setMacroRatio] = React.useState(Util.getMacroNutrientRatio(goal.eatingStyle!));

	const valueClicked = (value?: string) => {
		AnalyticsApi.logEvent('Macronutrient Selected');
		if (typeof value === 'undefined') {
			goal.macroNutrient = new Macronutrient(macroRatio, GraphMode.standard);
		}
		valueSelected(value);

	};

	React.useEffect(() => {
		const macroRatio = Util.getMacroNutrientRatio(goal.eatingStyle!);
		setMacroRatio(macroRatio);

		const stateModel = JSON.parse(JSON.stringify(Util.graphState))
		stateModel.datasets[0].data = [macroRatio.protein, macroRatio.carbs, macroRatio.fats];
		setGraphData(JSON.parse(JSON.stringify(stateModel)));
	}, []);

	const renderGraph = () => {
		if (mode === GraphMode.standard) {
			return (
				<div className="graph-group">
					<div className="graph-container">
						<Doughnut data={graphData} options={{}} />
						<div>
							<span className='bubble blue'></span> ~{macroRatio.protein}% Protein
							<span className='bubble orange'></span> ~{macroRatio.carbs}%  Carbs
							<span className='bubble yellow'></span> ~{macroRatio.fats}% Fats
						</div>
					</div>
				</div>
			);
		}
	};

	const renderButtons = () => {
		if (mode === GraphMode.standard) {
			return (
				<div className="">
					<button className="greenButton" onClick={(e) => valueClicked()}>
						Use Standard
					</button>

					<button className="greenButton" onClick={(e) => valueClicked("custom")}>
						Customize
					</button>
				</div>
			);
		}
	};

	return (
		<div className="content">
			{renderGraph()}
			{renderButtons()}
		</div>
	);
};

export default MacroNutrient;
